//Open all links that have 'rel=external' to open in a new tab
$('body').on('click', 'a[rel="external"]', function() {
    window.open($(this).attr('href'));
    return false;
});

define("plugins/open-new-tab", function(){});

